export abstract class CurrentItem {
	static storageItem: string;
	static baseRoute: string;
	static returnProperties: string;

	static async readIf(identifier?: string): Promise<any> {
	};

	static get(): any {
	};

}